export default __webpack_public_path__ + "static/media/oliestort.67a4f441.svg";